// extracted by mini-css-extract-plugin
export default {"main":"Admin_main__eNTcg"};